module.exports = __webpack_public_path__ + "img/animals_penguin.54a2a521.png";